import React, { useEffect } from "react";
import { NavLink } from "react-router-dom";
import "./header.scss";
import Navigation from "./nav";
import logo from "../../img/logo.png";
import $ from "jquery";
function HeaderSection() {
  const onButtonClick = () => {
    const pdfUrl = "/assets/img/AM-PM-ENGINEERING-CATALOG.pdf";
    const link = document.createElement("a");
    link.href = pdfUrl;
    link.download = "AM-PM-ENGINEERING-CATALOG.pdf"; // specify the filename
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
};
  return (
    <>
      <div className="top-nav">
        <span className="mob-menu">Menu</span>
        <a className="logo" href="/">
          <span>
            <img src={'./assets/img/am-pm-logo.png'} />
          </span>
        </a>
        <ul className="nav float-right nav-top-space">
          <li className="nav-item">
            <NavLink className="nav-link" to="/home" activeClassName="active">
              Home
            </NavLink>
            {/* <a className="nav-link"  href="/">
              Home
            </a> */}
          </li>
          <li className="nav-item">
            <NavLink
              className="nav-link"
              to="/about-us"
              activeClassName="active"
            >
              About
            </NavLink>
            {/* <a className="nav-link" data-goto href="/about-us">
              About
            </a> */}
          </li>
          <li className="nav-item">
            <NavLink
              className="nav-link"
              activeClassName="active"
              to="/industries-we-serve"
            >
              Industries We Serve
            </NavLink>
            {/* <a className="nav-link" href="/industries-we-serve">
              Industries We Serve
            </a> */}
          </li>
          <li className="nav-item">
            <a
              className="nav-link"
              href="#"
              onClick={onButtonClick}
            >
              Catlogue
            </a>
          </li>
          <li className="nav-item">
            <NavLink
              className="nav-link"
              activeClassName="active"
              to="/contact-us"
            >
              Contact
            </NavLink>
            {/* <a className="nav-link" href="/contact-us">
              Contact
            </a> */}
          </li>
        </ul>
      </div>
      <Navigation />
    </>
  );
}

export default HeaderSection;
